import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { logRequest } from 'app/main/shared/http-utils';
import { Observable } from 'rxjs';
import { SalaryTypeSearch } from '../salary-type/salary-type-search.model';
import { ISalaryType } from '../salary-type/salary-type.model';

@Injectable({
    providedIn: 'root',
})
export class SalaryTypeService {
    baseUrl = '/school-service/api/salary-types';

    constructor(private http: HttpClient) {}

    create(salaryType: ISalaryType): Observable<HttpResponse<ISalaryType>> {
        console.log(salaryType);
        return this.http.post<ISalaryType>(this.baseUrl, salaryType, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    update(salaryType: ISalaryType): Observable<HttpResponse<ISalaryType>> {
        return this.http.put<ISalaryType>(this.baseUrl, salaryType, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    delete(salaryType: ISalaryType): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${salaryType.id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    getById(id: string): Observable<HttpResponse<ISalaryType>> {
        return this.http.get<ISalaryType>(`${this.baseUrl}/${id}`, {
            observe: 'response',
        });
    }

    getAll(): Observable<ISalaryType[]> {
        return this.http.get<ISalaryType[]>(this.baseUrl);
    }

    getAllActives(): Observable<ISalaryType[]> {
        return this.http.get<ISalaryType[]>(`${this.baseUrl}/active`);
    }

    getAllActiveByCurrentUserRoles(): Observable<ISalaryType[]> {
        return this.http.get<ISalaryType[]>(`${this.baseUrl}/active/roles`);
    }

    getAllActiveByCurrentUserRolesAndNotInEmployee(employeeId?: string): Observable<ISalaryType[]> {
        const id = employeeId ? `${employeeId}` : '';
        return this.http.get<ISalaryType[]>(`${this.baseUrl}/active/roles/employee/${id}`);
    }

    getAllActiveNotInEmployee(employeeId: string): Observable<ISalaryType[]> {
        return this.http.get<ISalaryType[]>(`${this.baseUrl}/active/employee/${employeeId}`);
    }

    search(search: SalaryTypeSearch): Observable<HttpResponse<ISalaryType[]>> {
        return this.http.post<ISalaryType[]>(`${this.baseUrl}/search`, search, {
            observe: 'response',
        });
    }
}
